export const loadStorage = () => {
  const store = localStorage.getItem("ai-state");
  try {
    if (store === null) {
      return undefined;
    } else {
      return JSON.parse(store);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("Error While Getting LocalStorage State!!!");
  }
};

export const saveStorage = (state: any) => {
  try {
    const store = JSON.stringify(state);
    return localStorage.setItem("ai-state", store);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("Error While Saving LocalStorage State!!!");
  }
};
